import { useEffect, useState } from "react";
import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import { BuilderTranslate } from "./types";

type TableOption = { id: string; name: string; label: string };
const normalize = (value: string) => value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

export default function NewViewDialog({ open, suggestion, onCancel, onCreate, tr, tables, selectedTable, busy = false }: {
    open: boolean; suggestion: string; onCancel: () => void; onCreate: (name: string, table?: TableOption) => void; tr: BuilderTranslate;
    tables?: TableOption[]; selectedTable?: TableOption | null; busy?: boolean;
}) {
    const [name, setName] = useState(suggestion);
    const [table, setTable] = useState<TableOption | null>(selectedTable ?? null);
    const [submitted, setSubmitted] = useState(false);
    useEffect(() => { if (open) { setName(suggestion); setTable(selectedTable ?? null); setSubmitted(false); } }, [open, suggestion, selectedTable]);
    const valid = name.trim().length > 0 && (!tables || Boolean(table));
    return <Dialog open={open} onClose={busy ? undefined : onCancel} fullWidth maxWidth="xs"
        PaperProps={{ component: "form", onSubmit: (event: React.FormEvent) => { event.preventDefault(); if (valid && !busy && !submitted) { setSubmitted(true); onCreate(name.trim(), table ?? undefined); } } } as object}>
        <DialogTitle>{tr("new_view_title", "New view")}</DialogTitle>
        <DialogContent>
            {tables && <Autocomplete options={tables} value={table} onChange={(_, value) => setTable(value)}
                getOptionLabel={option => `${option.label} · ${option.name}`} isOptionEqualToValue={(option, value) => option.id === value.id}
                filterOptions={(options, state) => options.filter(option => normalize(`${option.label} ${option.name}`).includes(normalize(state.inputValue)))}
                renderInput={params => <TextField {...params} margin="dense" label={tr("choose_table_for_view", "Choose a table for the view")} />} />}
            <TextField autoFocus fullWidth margin="dense" label={tr("view_name", "View name")} value={name} onChange={event => setName(event.target.value)}
                helperText={tr("view_name_help", "You can rename it later.")} />
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button variant="text" color="inherit" disabled={busy} onClick={onCancel}>{tr("cancel", "Cancel")}</Button>
            <Button type="submit" variant="contained" disabled={!valid || busy || submitted}>{tr("create_view", "Create view")}</Button>
        </DialogActions>
    </Dialog>;
}
